import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import user_service from "../service/user_service";
import Loader from "../../Pages/Loader/Loader.js";
import Toaster from "../../Pages/Toaster/Toaster";

export default function NewsletterArchive() {
  const navigate = useNavigate();
  const [loader, setLoader] = useState({ isActive: null });
  const { isActive } = loader;

  const [toaster, setToaster] = useState({
    types: null,
    isShow: null,
    toasterBody: "",
    message: "",
  });
  const { types, isShow, toasterBody, message } = toaster;

  const [q, setQ] = useState("");
  const [items, setItems] = useState([]);

  const fetchList = async () => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    const query = params.toString() ? `?${params.toString()}` : "";

    setLoader({ isActive: true });
    try {
      const res = await user_service.newslettersArchiveList(query);
      setItems(res?.data?.data || []);
    } catch (e) {
      setToaster({
        types: "error",
        isShow: true,
        toasterBody: e?.response?.data?.message || "Failed to load archive.",
        message: "Error",
      });
    } finally {
      setLoader({ isActive: false });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="bg-secondary float-left w-100 pt-4">
      <Loader isActive={isActive} />
      {isShow && (
        <Toaster types={types} isShow={isShow} toasterBody={toasterBody} message={message} />
      )}
      <main className="page-wrapper">
        <div className="container pb-5">
          <div className="d-flex align-items-center justify-content-between mb-4">
            <h3 className="text-white mb-0">Newsletter Archive</h3>
            <NavLink className="btn btn-secondary" to="/">
              Home
            </NavLink>
          </div>

          <div className="bg-light border rounded-3 p-3 mb-3">
            <div className="row g-2 align-items-end">
              <div className="col-md-9">
                <label className="form-label">Search</label>
                <input
                  className="form-control"
                  value={q}
                  onChange={(e) => setQ(e.target.value)}
                  placeholder="Search by title"
                />
              </div>
              <div className="col-md-3 d-flex gap-2">
                <button className="btn btn-primary w-100" type="button" onClick={fetchList}>
                  Search
                </button>
                <button
                  className="btn btn-outline-secondary w-100"
                  type="button"
                  onClick={() => {
                    setQ("");
                    setTimeout(fetchList, 0);
                  }}
                >
                  Reset
                </button>
              </div>
            </div>
          </div>

          <div className="bg-light border rounded-3 p-0 overflow-hidden">
            {items?.length ? (
              <div className="list-group list-group-flush">
                {items.map((n) => (
                  <button
                    key={n._id}
                    type="button"
                    className="list-group-item list-group-item-action d-flex align-items-center justify-content-between"
                    onClick={() => navigate(`/newsletter-archive/${n._id}`)}
                  >
                    <div>
                      <div className="fw-semibold">{n.title}</div>
                      <div className="text-muted small">
                        {n.publishDate ? `Published: ${new Date(n.publishDate).toLocaleDateString()}` : ""}
                        {n.sentAt ? ` · Sent: ${new Date(n.sentAt).toLocaleString()}` : ""}
                      </div>
                    </div>
                    <div className="text-muted small">Read-only</div>
                  </button>
                ))}
              </div>
            ) : (
              <div className="p-3 text-muted">No newsletters in the archive yet.</div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}

